import { translateKeys, translateValues } from '@atc/bonnet-parameters';
import { getIndexedLocationFilters, getMarket } from '@atc/bonnet-reference';
import pageNames from './pageNames';
import getRequiredKeys from './getRequiredKeys';
export default async function queryPostProcessor(_ref) {
  var _query$searchRadius;
  let {
    pageName,
    query,
    target
  } = _ref;
  // Remove any seo specific or required query params from the pathname
  query = Object.entries(query).reduce((acc, _ref2) => {
    let [key, value] = _ref2;
    // remove any unencoded seo query parameters
    if (key.slice(0, 3) === 'seo') {
      return acc;
    }

    // remove any falsey values although allow false Boolean to remain
    if (query[key] !== false && !query[key]) {
      return acc;
    }

    // TODO: why does this exist?  We need a comment explaining
    if (pageName !== pageNames.VEHICLE_DETAILS && getRequiredKeys(pageName).includes(key)) {
      return acc;
    }
    return {
      ...acc,
      [key]: value
    };
  }, {});

  // remove searchRadius if the is no zip code or the zip is the default value (50 or 25 depending on location)
  let defaultSearchRadius = '50';
  if (query.zip) {
    var _payload$defaultSearc;
    const {
      payload
    } = await getMarket(query.zip);
    defaultSearchRadius = payload === null || payload === void 0 || (_payload$defaultSearc = payload.defaultSearchRadius) === null || _payload$defaultSearc === void 0 ? void 0 : _payload$defaultSearc.toString();
  }
  if (((_query$searchRadius = query.searchRadius) === null || _query$searchRadius === void 0 ? void 0 : _query$searchRadius.toString()) === defaultSearchRadius) {
    delete query.searchRadius;
  }

  // remove zip code if the query param matches the center zip code
  if (query.location) {
    var _query$location$city, _query$location$state;
    const city = (_query$location$city = query.location.city) === null || _query$location$city === void 0 ? void 0 : _query$location$city.toLowerCase().replace(' ', '-');
    const state = (_query$location$state = query.location.state) === null || _query$location$state === void 0 ? void 0 : _query$location$state.toLowerCase();
    const ccZip = await getIndexedLocationFilters({
      city,
      state
    });
    if (ccZip.success) {
      if (query.zip === ccZip.payload.centerZip) {
        delete query.zip;
      }
    }
  }

  // remove excessive params
  delete query['0'];
  delete query.requestId;
  delete query.showAccelerateBanner;

  // translate all param values to specified target format
  query = translateValues(query, {
    target
  });

  // translate all param keys to specified target format
  query = translateKeys(query, {
    target
  });
  return query;
}